/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import FormField, { CustomFormFieldProps } from './FormField'
import { Textarea, TextareaProps } from '@mantine/core'

export type FormTextareaFieldProps = CustomFormFieldProps<TextareaProps>

function FormTextareaField (props: FormTextareaFieldProps) {
  const { name, ...others } = props
  return (
    <FormField
      {...others}
      name={name}
      render={Textarea}
    />
  )
}

export default FormTextareaField
